/**
 * StarPRNT raster. ESC GS S prints a monochrome block.
 * ESC d 2 feeds the slip to the cutter, then cuts.
 * This is not the TSP100 ESC * r sequence.
 */

const ESC = 0x1b
const GS = 0x1d
const MAX_ROWS = 2048

export function canvasToStarPrnt(canvas: HTMLCanvasElement): Uint8Array {
    const context = canvas.getContext('2d', { willReadFrequently: true })
    if (!context) throw new Error('Could not get canvas context')
    const width = canvas.width
    const height = canvas.height
    const bytesPerRow = Math.ceil(width / 8)
    if (bytesPerRow < 1 || bytesPerRow > 128) {
        throw new Error('StarPRNT raster width is out of range')
    }
    const { data } = context.getImageData(0, 0, width, height)
    const parts: Uint8Array[] = [Uint8Array.from([ESC, 0x40])]

    for (let top = 0; top < height; top += MAX_ROWS) {
        const rows = Math.min(MAX_ROWS, height - top)
        const raster = new Uint8Array(bytesPerRow * rows)
        for (let y = 0; y < rows; y++) {
            const sourceY = top + y
            for (let x = 0; x < width; x++) {
                if (data[(sourceY * width + x) * 4] < 200) {
                    raster[y * bytesPerRow + (x >> 3)] |= 0x80 >> (x & 7)
                }
            }
        }
        const header = Uint8Array.from([
            ESC, GS, 0x53, 0x01,
            bytesPerRow & 0xff, (bytesPerRow >> 8) & 0xff,
            rows & 0xff, (rows >> 8) & 0xff,
            0x00,
        ])
        const block = new Uint8Array(header.length + raster.length)
        block.set(header, 0)
        block.set(raster, header.length)
        parts.push(block)
    }

    parts.push(Uint8Array.from([ESC, 0x64, 0x02]))
    const length = parts.reduce((sum, part) => sum + part.length, 0)
    const buffer = new Uint8Array(length)
    let offset = 0
    for (const part of parts) {
        buffer.set(part, offset)
        offset += part.length
    }
    return buffer
}
